module.exports = __webpack_public_path__ + "static/img/dengyunze.3c8260d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/dengyunze.png
// module id = wJNz
// module chunks = 0